<template>
  <section v-if="ready" class="intro-page">
    <g-title tag="h1">{{ chatPage.Title }}</g-title>
    <g-markdown :content="chatPage.Text" />
    <g-button @click.prevent="openChat">
      TA MIG TILL CHATTEN
    </g-button>
    <g-button @click.prevent="$router.push({ name: 'question-blocks' })">
      NEJ TACK. INTE JUST NU
    </g-button>
  </section>
</template>
<script>
import GET_QUESTION_BLOCKS from '@/graphql/question-block/GetQuestionBlocks.gql';
import { DateTime } from 'luxon';

import config from '@/services/config.js';

export default {
  components: {},
  data() {
    return {
      ready: false,
      questionBlocks: [],
      chatPage: {
        Title: '',
        Text: ''
      }
    };
  },
  created() {
    this.$apollo
      .query({
        query: GET_QUESTION_BLOCKS,
        variables: {
          id: this.$route.params.id
        }
      })
      .then(({ data: { questionBlocks } }) => {
        this.questionBlocks = questionBlocks;
        this.checkChats();
      });
  },
  methods: {
    async checkChats() {
      // ChatDates
      let activeChats = [];
      let questionBlockId = false;
      let questionBlock = false;

      const currentDateTime = DateTime.local();
      currentDateTime.setZone('europe/Stockholm');
      for (let outerIndex in this.questionBlocks) {
        let blockData = this.questionBlocks[outerIndex];
        for (let index in blockData.ChatDates) {
          const chatDate = blockData.ChatDates[index];
          const startDateTime = DateTime.fromISO(chatDate.StartDate, {
            zone: 'europe/Stockholm'
          });
          const endDateTime = DateTime.fromISO(chatDate.EndDate, {
            zone: 'europe/Stockholm'
          });

          if (
            currentDateTime >= startDateTime &&
            currentDateTime <= endDateTime
          ) {
            activeChats.push(parseInt(blockData.id));
          }
        }
      }

      if (
        activeChats.length &&
        activeChats.includes(parseInt(this.$route.params.id))
      ) {
        for (let outerIndex in this.questionBlocks) {
          let blockData = this.questionBlocks[outerIndex];
          if (parseInt(blockData.id) === parseInt(this.$route.params.id)) {
            const chatIsOpen = await this.isChatOpen();

            if (chatIsOpen) {
              this.chatPage.Title = blockData.ChatTitle;
              this.chatPage.Text = blockData.ChatIntro;
              this.ready = true;
            } else {
              this.$router.push({ name: 'question-blocks' });
            }
          }
        }
      } else {
        this.$router.push({ name: 'question-blocks' });
      }
    },
    async openChat() {
      let chatStatus = null;

      try {
        chatStatus = await window.fetch(config.CHAT_URL);
        chatStatus = await chatStatus.json();
      } catch (err) {
        await this.$router.push({ name: 'question-blocks' });
      }

      if (chatStatus.status !== 'ok') {
        await this.$router.push({ name: 'question-blocks' });
      }

      const sessionItem = window.sessionStorage.getItem('userObject');
      // Checks if the session item is not set,
      // if so just return
      if (!sessionItem) {
        // Go back to the questions
        await this.$router.push({ name: 'question-blocks' });
      }

      let userObject = JSON.parse(sessionItem);
      let chatNick = '';

      if (userObject && userObject.formData && userObject.formData.gender) {
        switch (userObject.formData.gender) {
          case 'tjej':
            chatNick = 'Tjej';
            break;
          case 'kille':
            chatNick = 'Kille';
            break;
          case 'ickebinar':
            chatNick = 'Icke binär';
            break;
          case 'annat':
            chatNick = 'Annat alternativ';
            break;
          case 'vill inte svara':
            chatNick = 'Vill inte svara';
            break;
          default:
            chatNick = 'Besökare';
        }
      } else {
        chatNick = 'Besökare';
      }

      if (userObject && userObject.formData && userObject.formData.age) {
        chatNick += ', ' + userObject.formData.age;
      }

      let chatUrl = chatStatus.chat + '&name=' + encodeURIComponent(chatNick);
      window.location.href = chatUrl;
    },

    async isChatOpen() {
      let chatStatus = false;
      try {
        chatStatus = await window.fetch(config.CHAT_URL);
        chatStatus = await chatStatus.json();
        return chatStatus.status === 'ok';
      } catch (err) {
        this.$router.push({ name: 'question-blocks' });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.second-title {
  margin-top: 50px;
}

.gdpr {
  margin-bottom: 30px;
}
</style>
